<template>
    
    <span id="projectList">
        
        <embed src="/CV_Bonny-Y-Wang.pdf" type="application/pdf" width="100%" height="100%" />
    
    </span>
</template>

<script>
export default {
    name:"CV",
}
</script>

<style>


</style>